export const titleCase = (str: string): string => {
  const splitStr = str.toLowerCase().split(' ')
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  return splitStr.join(' ')
}

export const buildQueryUrl = (
  base: string = '', 
  pathname: string = '', 
  parameters: Record<string, string | number | boolean | null | undefined> = {}
): string => {
  const queryItems: string[] = []

  let url = `${base}${pathname}`

  Object.entries(parameters).forEach(([key, value]) =>
    value ? queryItems.push(`${key}=${value}`) : null
  )

  url += `${queryItems.length > 0 ? '?' + queryItems.join('&') : ''}`

  return url
}

export const buildApiUrl = (
  pathname: string, 
  parameters: Record<string, string | number | boolean | null | undefined>
): string =>
  buildQueryUrl(`${process.env.API_V2_URL}`, pathname, parameters)

export const isDecimal = (value: string): boolean => {
  return /^\d*\.?\d*$/.test(value)
}

export const getParameterByName = (name: string, url: string = window.location.href): string | null => {
  name = name.replace(/[\[\]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const isMaintMode = (): boolean => {
  return process.env.MAINT_MODE === 'true'
} 